/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CategoryList } from '../../models/category-list';

export interface GetDataSourcesOrgName$Params {
  orid: number;
}

export function getDataSourcesOrgName(http: HttpClient, rootUrl: string, params: GetDataSourcesOrgName$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CategoryList>>> {
  const rb = new RequestBuilder(rootUrl, getDataSourcesOrgName.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CategoryList>>;
    })
  );
}

getDataSourcesOrgName.PATH = '/api/MasterDataSource/{orid}';
